export const messages = {
  title: {
    id: "session-notes.title",
    defaultMessage: "Session Notes",
  },
  search: {
    id: "session-notes.search",
    defaultMessage: "Search session notes",
  },
  empty: {
    id: "session-notes.empty",
    defaultMessage: "You have not created any note yet",
  },
  emptySearch: {
    id: "session-notes.empty-search",
    defaultMessage: "There are no notes matching your search criteria",
  },
  noteTitle: {
    id: "session-notes.note-title",
    defaultMessage: "{{planTitle}}: Volume {{volumeNumber}}, {{sessionNumber}}",
  },
  noteTitleShort: {
    id: "session-notes.note-title-short",
    defaultMessage: "Volume {{volumeNumber}}, {{sessionNumber}}",
  },
};
